import styled from "styled-components";

const Textarea = styled.textarea`
  // reset styles
  margin-top: 0;
  resize: vertical;
  overflow: auto;
  min-height: 143px;
  height: 143px;

  width: 100%;
  padding: 12px 16px 0;
  border-radius: 8px;

  border: solid 1px var(--foam);
  background-color: var(--cream);
  font-size: var(--textM);
  line-height: 1.38;
  color: var(--husk);

  // other
  &::placeholder {
    color: var(--rock);
  }

  &:focus {
    outline: 0;
    background-color: var(--white);
    border-color: #e2f5f4;
    box-shadow: 0 0 0 0.2rem rgba(131, 212, 208, 0.25);
  }
`;

export default Textarea;
